import cn from 'classnames';
import styles from './aspectratio.module.scss';
import { AspectRatioProps, RatioBreakpoints } from './AspectRatio.type';

export function AspectRatio({ cols, clip = true, children, className }: AspectRatioProps) {
    const ratioClasses = Object.keys(cols).map((breakpoint) => {
        const bp = breakpoint as keyof RatioBreakpoints;
        return styles[`ratio-${breakpoint}-${cols[bp]}`];
    });

    const classNames = cn(styles.aspectRatio, ratioClasses, className, {
        [styles.clip]: clip,
    });

    return <div className={classNames}>{children}</div>;
}
